import {AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild} from '@angular/core';
import {ButtonControl, flatMap} from '../../../models/uiArtefakt';
import {TrackingAktion} from '../../../models/enumTracking';
import {ButtonCommandService} from '../../../services/button-command.service';
import {NgForm} from '@angular/forms';
import {UIDarstellungsart} from '../../../models/uiDarstellungsart';
import {ShellConfigService} from '../../../services/shell-config.service';
import {Command} from '../../../models/command';
import {Notification, NotificationService, RuntimeContext, StringUtils} from '@lv1871/core';
import {MatSnackBar, MatSnackBarConfig} from '@angular/material/snack-bar';
import {EventService} from '../../../services/event.service';
import {Subscription, tap} from 'rxjs';
import {TrackingService} from '../../../services/tracking.service';

@Component({
    selector: 'lv-button',
    templateUrl: './process-button.component.html',
    styleUrls: ['./process-button.component.scss'],
    standalone: false
})
export class ProcessButtonComponent implements OnInit, OnDestroy, AfterViewInit{

  @ViewChild(NgForm, {static: true})
  private _ngForm;

  public isDisabled: boolean = false;
  public loading: boolean;
  public votumErgebnis: string = 'Ablehnen';

  private _uiArtefakt: ButtonControl;
  private _validationStateSubscription$ = Subscription.EMPTY;
  private _isAntragStreckeFullyValid: boolean;
  private _uiControlSubscription$ = Subscription.EMPTY;

  constructor(public snackBar: MatSnackBar, private _eventService: EventService,
              private _commandService: ButtonCommandService,
              private _shellConfigService: ShellConfigService,
              private _tracker: TrackingService,
              private _notificationService: NotificationService,
              private _renderer: Renderer2,
              private _element: ElementRef) {
  }

  get uiArtefakt(): ButtonControl {
    return this._uiArtefakt;
  }

  @Input() set uiArtefakt(uiArtefakt: ButtonControl) {
    this._uiArtefakt = uiArtefakt;
    this.isDisabled = this._uiArtefakt?.Darstellungsart === UIDarstellungsart.DISABLED;
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

  ngOnInit(): void {
    this._validationStateSubscription$ = this._eventService.validationState$.pipe(
        tap(stateMap => this._isAntragStreckeFullyValid = !Array.from(stateMap.values()).includes(false))).subscribe();
    this._uiControlSubscription$ = this._eventService.uiControls$.subscribe(uiControl => {
      const ergebnis = flatMap(uiControl.uiVorgang.UIArtefakt)
      .filter(artefakt => !!artefakt.FeldnameExtern && artefakt.FeldnameExtern === '/votum/votumErgebnis')[0];
      this.votumErgebnis = !!ergebnis ? ergebnis.WertEingabe : 'Ablehnen';
    });
  }

  ngOnDestroy(): void {
    if (this._validationStateSubscription$) {
      this._validationStateSubscription$.unsubscribe();
    }
    if(this._uiControlSubscription$){
      this._uiControlSubscription$.unsubscribe();
    }
  }

  onCommand() {
    this.trackProcessButton();
    this.loading = true;
    this._commandService.handleCommand(this._uiArtefakt).subscribe({
      next: response => {
        this.loading = false;
        const notification = new Notification(
            'Alert', 'Positive', null,
            'Ihr Angebot wurde gespeichert',
            false, 3000);
        this._notificationService.addNotification(notification);
        if (!!response && StringUtils.isNotNull(this._uiArtefakt.RedirectUrl)) {
          this._eventService.supressBeforeUnloadDialogButtonClicked$.next();
          window.location.replace(this._uiArtefakt.RedirectUrl);
        }
      },
      error: () => {
        this.loading = false;
        const notification = new Notification(
            'Alert', 'Danger', null, '\"' + this._uiArtefakt.Text + '\" konnte aufgrund eines technischen Fehlers nicht ausgeführt werden.',
            true, null);
        this._notificationService.addNotification(notification);
      },
    });
  }

  showButton() {
    return !(this._shellConfigService.getParameter().runtimeContext === RuntimeContext.SB_SHELL &&
        (this._uiArtefakt.Command === Command.BEANTRAGEN ||
            this._uiArtefakt.Command === Command.ANGEBOT ||
            this._uiArtefakt.Command === Command.SPEICHERN));
  }

  private _getSnackBarConfig(): MatSnackBarConfig {
    const config = new MatSnackBarConfig();
    config.verticalPosition = 'top';
    config.horizontalPosition = 'center';
    config.duration = 5000;
    return config;
  }

  private trackProcessButton() {
    if (this.uiArtefakt.FeldnameTracking) {
      this._tracker.trackEvent(this.uiArtefakt.Command, TrackingAktion.T_BUTTON, this.uiArtefakt.FeldnameTracking);
    }
  }

}
